import * as React from 'react';
import { connect } from 'react-redux';
import { fetchSeller, editSeller } from '../../actions/sellersActions';
import Tab from '../General/Tab';
import { toast } from 'react-toastify';
import DatosBasicos from './DatosBasicos';
import DatosContactos from './DatosContactos';
import Publicacion from './Publicacion';
import Moderador from './Moderador';
import MailUsuario from './MailUsuario';
import { postSeller } from '../../api/axios';
import { editando, setObject } from '../../actions/generalActios';
import { setTiposPublicacion } from '../../actions/tiposPublicacionActions';
import { postTiposPublicacionAsociarSeller } from '../../api/axios';
import Liquidacion from './Liquidacion';
import MiniSpinner from '../General/MiniSpinner';
import GoBackArrow from '../General/GoBackArrow';
import { isEmail } from '../../utilities/formatString';

class SellerNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: this.props.location.state ?? 0,
            tabs: [
                { name: "Datos Básicos ", icon: "ti-home", content: <DatosBasicos /> },
                { name: "Datos de contactos", icon: "ti-home", content: <DatosContactos /> },
                { name: "Publicación", icon: "ti-home", content: <Publicacion history={this.props.history} /> },
                { name: "Moderador", icon: "ti-home", content: <Moderador tipoUsuario={this.props.tipoUsuario} history={this.props.history} /> },
                { name: "Usuario", icon: "ti-home", content: <MailUsuario /> },
                { name: "Liquidacion", icon: "ti-home", content: <Liquidacion tipoUsuario={this.props.tipoUsuario} /> }
            ],
            showSpinner: false
        }
    };

    componentDidMount() {
        if (this.props.history.location.pathname != "/Sellers/Nuevo/Select") {
            this.props.setObject({});
        }
        this.props.editando(false);
        this.props.fetchSeller();
    }

    onChangeActiveTab = (index) => {
        this.setState({ activeTab: index });
    }

    asignarTipoPublicacion = (idSeller) => {

        let listaIdTiposPublicaciones = [];

        for (let index = 0; index < this.props.settedTiposPublicacion.length; index++) {
            let element = this.props.settedTiposPublicacion[index].codigo;
            if (element != undefined) {
                listaIdTiposPublicaciones.push(element);
            }
        }

        let request = {
            "idSeller": idSeller,
            "listaIdsTipoPublicacion": listaIdTiposPublicaciones
        };

        const req = postTiposPublicacionAsociarSeller(request);
        req.then(res => {
            toast.success("Tipo de publicación asociado");
        }).catch(err => {
            toast.warn("Tipo de publicación no asociado");
        });
    }

    onSubmit = async (event) => {
        event.preventDefault();

        if (this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2) {

            let seller = this.props.seller;

            if (!isEmail(seller.email)) {
                toast.warn("e-Mail contacto comercial incorrecto");
                return;
            }

            if (!isEmail(seller.emailUsuario)) {
                toast.warn("e-Mail de usuario incorrecto");
                return;
            }

            this.setState({ showSpinner: true });

            this.props.seller["idEmpresaEnviopack"] = parseInt(this.props.seller.idEmpresaEnviopack);
            this.props.seller["codigoPostal"] = parseInt(this.props.seller.codigoPostal);
            this.props.seller["numeroDomicilio"] = parseInt(this.props.seller.numeroDomicilio);
            this.props.seller["diasPlazoPago"] = parseInt(this.props.seller.diasPlazoPago);
            this.props.seller["diasCorte"] = parseInt(this.props.seller.diasCorte);

            let sellers = postSeller(this.props.seller);

            sellers.then(res => {
                this.asignarTipoPublicacion(res.idSeller);
                toast.success("Seller agregado");
                this.redirectToSellers();
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("El seller no pudo ser creado");
            }).finally(() => {
                this.setState({ showSpinner: false });
            });
        }
    }

    redirectToSellers = () => {
        this.props.history.push("/Sellers");
    }


    render() {
        return (
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-body p-b-0">

                        <div className="col-12 mb-3">
                            <GoBackArrow />
                            <h4 className="card-title d-block d-sm-inline">Nuevo Seller</h4>
                        </div>

                        <ul className="nav nav-tabs customtab" role="tablist">
                            {
                                this.state.tabs.map((tab, index) => {
                                    return (<div key={index} onClick={() => { this.onChangeActiveTab(index) }}>
                                        <Tab
                                            name={tab.name}
                                            icon={tab.icon}
                                            isActive={index == this.state.activeTab}
                                        />
                                    </div>)
                                })
                            }
                        </ul>

                        <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit}>
                            <div className="tab-content">

                                {this.state.tabs[this.state.activeTab].content}

                                <div className="row align-items-center justify-content-center text-center">
                                    <div className="col-12 col-sm-auto" hidden={!this.state.showSpinner}>
                                        <MiniSpinner />
                                    </div>

                                    <div className="col-12 col-sm-auto">
                                        <button
                                            type="submit"
                                            disabled={this.state.showSpinner}
                                            className="btn btn-sm background-rojo-megatone waves-light mx-2"
                                        >
                                            Guardar
                                        </button>
                                    </div>

                                    <div className="col-12 col-sm-auto">
                                        <button
                                            onClick={this.redirectToSellers}
                                            className="btn btn-sm btn-light waves-effect waves-light"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </form>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    idSeller: state.general.idSeller,
    tipoUsuario: state.general.tipoUsuario,
    settedSellerObject: state.general.generalObject,
    seller:
        JSON.stringify(state.general.generalObject) != "{}"
            ? state.general.generalObject
            : state.sellers.seller
    ,
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion
});

export default connect(mapStateToProps, {
    fetchSeller,
    editSeller,
    editando,
    setTiposPublicacion,
    setObject
})(SellerNew);